/**
 * =================================
 * tailwindcss 設定ファイル
 * =================================
 */
const colorConfig = require('./color');
const fontConfig = require('./font');
const objectConfig = require('./object');
const screenConfig = require('./screen');
const spacingConfig = require('./spacing');
export const tailwindConfig = {
    // NOTE: 既存の scss 記述となるべく分離したいので TypeScript のみ適応
    // https://tailwindcss.com/docs/using-with-preprocessors#using-sass-less-or-stylus
    content: ['./src/**/*.{tsx,ts}'],
    // Note: sass から移行完了後に @layer base 設定に変更
    // https://tailwindcss.com/docs/preflight#disabling-preflight
    corePlugins: {
        preflight: false,
    },
    theme: {
        borderRadius: objectConfig.borderRadius,
        boxShadow: objectConfig.boxShadow,
        colors: colorConfig.colors,
        dropShadow: objectConfig.dropShadow,
        extend: {
            backgroundColor: colorConfig.extend.backgroundColor,
            borderColor: colorConfig.extend.borderColor,
            fontSize: fontConfig.extend.fontSize,
            textColor: colorConfig.extend.textColor,
        },
        fontFamily: fontConfig.fontFamily,
        fontSize: fontConfig.fontSize,
        fontWeight: fontConfig.fontWeight,
        screens: screenConfig.screens,
        spacing: spacingConfig.spacing,
        textColor: colorConfig.colors,
    },
};
